<template>
  <div class="task-container">
    <div class="task-list">
      <div class="task-item" v-for="(item, index) in taskList" :key="index">
        <img class="item-icon" :src="item.icon" alt="" />
        <div class="item-center">
          <div class="item-title"
            >{{ item.title }}<span class="exp">+{{ item.exp }}经验值</span></div
          >
          <div class="item-desc" v-html="item.desc"></div>
          <div class="item-share" v-if="index == 2" @click="showPoster"
            >生成分享图<span class="iconfont icon-download"></span
          ></div>
        </div>
        <div
          class="item-btn"
          :class="{ 'item-btn-confirm': item.status == 1 }"
          @click="bindClickTask(item, index)"
          >{{ item.status == 1 ? '已完成' : item.btnText }}</div
        >
      </div>
    </div>
    <ShareComponent
      v-model="showShare"
      :poster="true"
      :posterUrl="posterUrl"
      :options="iconList"
      @cancel="bindCancel"
      @select="bindSelect"
      zIndex="9999"
    />
    <PosterImageComponent
      v-model="createPoster"
      :info="info"
      @finish="bindPosterFinish"
      @fail="bindPosterFail"
    />
  </div>
</template>
<script>
import { eventObj } from '@/components/app/share/share-method.js'
import ShareComponent from '@/components/app/share/share.vue'
import PosterImageComponent from './poster.vue'
import html2canvas from 'html2canvas'
export default {
  components: {
    ShareComponent,
    PosterImageComponent
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showShare: false,
      createPoster: false,
      posterUrl:
        'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-02/12962a14a8ad2f2eb4d6df8fa50136ff_wh=1101_2637.png',
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon1',
          name: '保存到手机',
          id: 5
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 6
        }
      ],
      taskList: [
        {
          icon: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/be4d0cfba398fd044fe1e9fb8eec16d9_wh=126_126.webp',
          title: 'APP首次约课额外',
          exp: 5,
          desc: '活动期间在APP首次约课<br/>（*APP约课每月额外获得12经验值）',
          btnText: '已过期',
          status: 0
        },
        {
          icon: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/262821311216aa3fe6edd89a74521703_wh=126_126.webp',
          title: '首次发布挑战记录',
          exp: 2,
          desc: '在圈子发布挑战书照片、在读的书、训练自拍等',
          btnText: '已过期',
          status: 0
        },
        {
          icon: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/d9bf2073a3e3528292fbee88370f0e5a_wh=126_126.webp',
          title: '上传分享截图',
          exp: 5,
          desc: '生成分享图并发布到小红书/朋友圈',
          btnText: '已过期',
          status: 0
        }
      ]
    }
  },
  watch: {
    info: {
      deep: true,
      handler() {
        this.updateTask()
      }
    }
  },
  created() {
    this.updateTask()
  },
  methods: {
    bindSelect(options) {
      this.showShare = false
      let shareOptions = {}
      switch (options.id) {
        case 5:
          eventObj.saveImageToPhone(this.posterUrl)
          break
        case 6:
          shareOptions.url = this.posterUrl
          eventObj.shareImageToWxCircle(shareOptions)
          break
      }
    },
    bindCancel() {},
    bindClickTask(item, index) {
      //活动结束禁止跳转
      return
      if (item.status) {
        return
      }
      this.$http.get('member/index?a=shareLogPush', {
        from: `project活动-任务列表${index + 1}-${
          this.$route.query.tfrom || ''
        }`,
        from_id: 250319
      })
      switch (index) {
        case 0:
          this.$betterwe.jumpRoute('/jMAppointment?isLogin=1')
          break
        case 1:
          ///punchInPublish?punchInType=-6&selectTopicId=xxx&coachId=xxx
          this.$betterwe.jumpRoute(
            '/punchInPublish?punchInType=-6&selectTopicId=147'
          )
          break
        case 2:
          this.selectPicture()
          break
      }
    },
    async selectPicture() {
      let res = await this.$betterwe.commonMethod('onAppCamera').catch(() => {})
      if (res) {
        res = JSON.parse(res)
        if (!Array.isArray(res)) {
          this.$toast('获取图片失败')
          return
        }
        this.uploadImage('data:image/png;base64,' + res[0])
      }
    },
    async uploadImage(imageBase64) {
      let res = await this.$http
        .uploadImg(imageBase64, 'activity_project')
        .catch(() => {
          this.$toast('上传图片异常')
        })
      if (res) {
        res = res.data
        if (res.code === 200 && res.data.savePath) {
          this.submitImage(res.data.savePath)
        } else {
          this.$toast('上传出错')
        }
      }
    },
    async submitImage(imageUrl) {
      let res = await this.$http
        .get('member/activity.ActProject?a=upShareImg', { share_url: imageUrl })
        .catch((err) => {
          this.$toast('异常错误')
        })
      if (res) {
        res = res.data
        if (res && res.code === 200) {
          this.$toast('上传成功')
          window?.onPageResumed()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    //显示海报
    showPoster() {
      this.$toast.loading('生成海报中')
      this.createPoster = true
    },
    bindPosterFail() {
      this.createPoster = false
    },
    bindPosterFinish() {
      this.createPoster = false
      html2canvas(document.getElementById('poster'), {
        backgroundColor: null,
        useCORS: true
      })
        .then((canvas) => {
          this.$toast.clear()
          this.posterUrl = canvas.toDataURL()
          this.$toast('海报已生成')
          this.showShare = true
        })
        .catch(() => {
          this.$toast.clear()
          this.$toast('生成海报出错')
        })
    },
    updateTask() {
      if (this.info) {
        this.taskList[0].status = this.info.is_app_class
        this.taskList[1].status = this.info.is_app_article
        this.taskList[2].status = this.info.share_url ? 1 : 0
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.task-container {
  .activity-title {
    text-align: center;
    font-family: MiSans, MiSans;
    font-weight: bold;
    font-size: 26px;
    color: #ffffff;
    line-height: 23px;
    margin-bottom: 11px;
  }

  margin-bottom: 26px;

  .task-list {
    padding: 21px 12px 21px 14px;
    background: #ffffff;
    border-radius: 10px;

    .task-item {
      margin-bottom: 30px;
      display: flex;
      align-items: flex-start;

      .item-icon {
        width: 42px;
        height: 42px;
        margin-right: 10px;
      }

      .item-center {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .item-title {
          font-family: MiSans, MiSans;
          font-weight: bold;
          font-size: 15px;
          color: #000000;
          line-height: 24px;

          .exp {
            margin-left: 2px;
            font-weight: bold;
            font-size: 16px;
            color: #ea3981;
            line-height: 22px;
          }
        }

        .item-desc {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 11px;
          color: rgba(0, 0, 0, 0.7);
          line-height: 18px;
        }

        .item-share {
          font-family: MiSans, MiSans;
          font-weight: bold;
          font-size: 14px;
          color: #11cc66;
          line-height: 24px;
          text-decoration: underline;
        }
      }

      .item-btn {
        margin-top: 6px;
        box-sizing: border-box;
        width: 64px;
        height: 30px;
        background: rgba(17, 204, 102, 0.4);
        border-radius: 15px;
        font-family: MiSans, MiSans;
        font-weight: bold;
        font-size: 14px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .item-btn-confirm {
        border: 2px solid #11cc66;
        background: #11cc66;
        font-weight: bold;
        font-size: 14px;
        color: #11cc66;
        background: #fff;
      }
    }

    .task-item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
